import { render, staticRenderFns } from "./CompetitionWordCloud.vue?vue&type=template&id=d86138b2&scoped=true"
import script from "./CompetitionWordCloud.vue?vue&type=script&lang=js"
export * from "./CompetitionWordCloud.vue?vue&type=script&lang=js"
import style0 from "./CompetitionWordCloud.vue?vue&type=style&index=0&id=d86138b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86138b2",
  null
  
)

export default component.exports